import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/notifications/styles.css';

import { AxiosError } from 'axios';

import { ServerError } from './components';
import { useAccount } from './features/auth';
import { useMessageLengthConfig } from './features/prophet';
import { AppRoutes } from './routes';

export const App = () => {
  const { data, isInitialLoading, isFetching, isError, error, refetch } = useAccount();

  // Load runtime message-length limits once at app start. Fire-and-forget:
  // the response updates the in-memory chunk-limits store; on failure the
  // rule editors keep using the built-in defaults.
  useMessageLengthConfig();

  if (isInitialLoading) {
    return null;
  }

  const isUnauthorized = error instanceof AxiosError && error.response?.status === 401;
  const isServerError = isError && !data && !isUnauthorized;

  if (isServerError) {
    return <ServerError onRetry={refetch} isFetching={isFetching} />;
  }

  return <AppRoutes isAuthenticated={!!data?.account} />;
};
